/**
 * O selo de ambiente para o que vem do banco.
 *
 * Ele existe pela mesma razão que `DocumentStatusBadge`: a linha traz `string`,
 * o selo exige a união fechada do domínio, e a ponte entre as duas precisa ser
 * uma conferência — não um `as`.
 *
 * O que não é reconhecido aparece escrito, em vez de virar um selo sem cor. O
 * ambiente é a informação que separa uma nota de teste de uma nota real; um
 * valor inesperado aqui merece ser visto, não maquiado.
 */

import { EnvironmentBadge } from './EnvironmentBadge.js';
import { asFiscalEnvironment } from '../lib/environment.js';

export function EnvironmentCell({ value }: { value: string }) {
  const ambiente = asFiscalEnvironment(value);
  if (ambiente === null) {
    return (
      <span
        className="of-state of-state--neutral"
        title="Ambiente não reconhecido pelo domínio. O texto é o valor persistido."
      >
        <span className="of-mono">{value}</span>
      </span>
    );
  }
  return <EnvironmentBadge environment={ambiente} />;
}
